import React from 'react'
import cx from 'classnames'

import Icon, { IconName } from 'components/_new/ui/Icon/Icon'
import { CircleLoader } from 'components/_new/ui'

import s from './SelectableBoxView.scss'


const iconNamesMap = {
  plus: 'plusInCircle',
  checkmark: 'checkmarkInCircle',
  radio: 'circleInCircle',
  empty: 'filledEmptyCircle',
} as const

export const iconNames = Object.keys(iconNamesMap)
export const iconColors = [ 'brand', 'black' ] as const
export const iconPositions = [ 'topLeft', 'rightCenter' ] as const

type IconProps = {
  icon: keyof typeof iconNamesMap
  iconColor: typeof iconColors[number]
  iconPosition: typeof iconPositions[number]
  iconClassName?: string
}

export type SelectableBoxViewProps = {
  className?: string
  tag?: string
  withBg?: boolean
  fullWidth?: boolean
  isFetching?: boolean
  active?: boolean
  dataTestId?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
} & AllOrNothing<IconProps>

const SelectableBoxView: React.FunctionComponent<SelectableBoxViewProps> = (props) => {
  const {
    children, className, tag = 'button',
    icon, iconColor, iconPosition = 'topLeft', iconClassName,
    withBg, fullWidth, active, dataTestId,
    isFetching, onClick,
  } = props

  const composedIconClassName = cx(s.icon, iconClassName, s[iconPosition], {
    [s.circleLoader]: isFetching,
  })

  const iconName = (icon && iconNamesMap[icon]) as IconName

  const rootClassName = cx(s.selectableBox, className, {
    [s.withBg]: withBg,
    [s.fullWidth]: fullWidth,
    [s.active]: active,
  })

  const iconNode = Boolean(icon) && (
    isFetching
      ? <CircleLoader className={iconClassName} />
      : <Icon className={composedIconClassName} name={iconName} color={iconColor} noWrapper />
  )

  return React.createElement(
    tag,
    {
      className: rootClassName,
      'data-testid': dataTestId,
      onClick,
    },
    iconNode,
    children
  )
}


export default SelectableBoxView
